import { MenuListType, NavItem } from '@/components/menu/Menu';
import { Inbox } from '@novu/react';
import useTranslation from 'next-translate/useTranslation';
import { appearance, popoverArrow } from './customization';

function unreadCountLabel(unreadCount: number) {
	return unreadCount < 100 ? unreadCount : '99+';
}

export function HeaderNotifications({
	subscriberId,
	isPopoverOpen,
	handleTriggerPopover,
}: {
	subscriberId: string;
	isPopoverOpen: boolean;
	handleTriggerPopover: VoidFunction;
}) {
	const { t } = useTranslation();
	const notificationNav: MenuListType = {
		id: 'notification',
		icon: 'bellIcon',
		iconActive: 'bellActiveIcon',
		iconMobile: 'bellMobileIcon',
		iconMobileActive: 'bellMobileActiveIcon',
		iconInfo: 0,
		active: isPopoverOpen,
		label: t('common:notifications'),
	};

	return (
		<div className={'[&_.novu]:flex'}>
			<Inbox
				applicationIdentifier={process.env.NEXT_PUBLIC_NOVU_APP_IDENTIFIER ?? ''}
				subscriberId={subscriberId}
				open={isPopoverOpen}
				appearance={appearance}
				renderBell={(unreadCount: number) => (
					<div
						className={'relative flex'}
						onClick={(e) => {
							e.stopPropagation();
							handleTriggerPopover();
						}}>
						<NavItem item={{ ...notificationNav, ...(unreadCount && { iconInfo: unreadCountLabel(unreadCount) }) }} />
						{isPopoverOpen && <div className={popoverArrow}></div>}
					</div>
				)}
			/>
		</div>
	);
}
